import React from 'react';
import { useParams } from 'react-router-dom';
import { caseStudyRegistry } from '../constants/caseStudies/registry';
import { CaseStudyTemplate1Data, CaseStudyTemplate2Data } from '../constants/caseStudies/types';
import CaseStudyTemplate1 from './CaseStudyTemplate1';
import CaseStudyTemplate2 from './CaseStudyTemplate2';
import Page404 from '../views/landing/404';

interface Props {}

const CaseStudy = (props: Props) => {
  const {} = props;
  const { slug } = useParams<{ slug: string }>();

  if (!slug) {
    return <Page404 />;
  }

  const caseStudy = caseStudyRegistry.getBySlug(slug);

  if (!caseStudy) {
    return <Page404 />;
  }

  // Render Template 1
  if (caseStudy.metadata.template === 1) {
    return <CaseStudyTemplate1 caseStudyData={caseStudy.data as CaseStudyTemplate1Data} metadata={caseStudy.metadata} />;
  }

  // Render Template 2
  if (caseStudy.metadata.template === 2) {
    return <CaseStudyTemplate2 caseStudyData={caseStudy.data as CaseStudyTemplate2Data} metadata={caseStudy.metadata} />;
  }

  return <Page404 />;
};

export default CaseStudy;

